class ColorSwatches extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('.card__swatch').forEach((swatch) =>
      swatch.addEventListener('click', this.onSwatchClick.bind(this))
    );
  }

  onSwatchClick(event) {
    event.preventDefault();
    var card = event.target.closest(`.card`);
    let variantId = event.target.dataset.variantId;
    let variantImages = this.querySelector('[data-product-variant-images]');
    const variantImagesData = JSON.parse(variantImages.textContent);
    variantImagesData.forEach((variantImage) => {
      if (variantImage[variantId]) {
        card.querySelector('.card__media .media').innerHTML = variantImage[variantId].image;
        card.querySelectorAll('a').forEach((link) => {
          link.href = variantImage[variantId].product_link;
        });
        this.querySelectorAll('.card__swatch').forEach((swatch) => {
          swatch.classList.remove('active');
        });
        event.target.classList.add('active');
      }
    });
  }
}

customElements.define('color-swatches', ColorSwatches);